const BrandChecker = {
    namespaced: true,
    state: {
        brandNamePills: []
    },
    getters: {
        getBrandNamePills(state) {
            return state.brandNamePills;
        },
        getBrandNameString(state) {
            return state.brandNamePills.map((item) => item.value).join(' ');
        }
    },
    mutations: {
        setBrandNamePillsState(state, payload) {
            state.brandNamePills = payload;
        },
    },
    actions: {
        addBrandNamePill({ commit, state }, pillObj) {
            let newBrandNamePillsArray = [...state.brandNamePills];

            newBrandNamePillsArray.push({
                value: pillObj.value,
                colorClass: pillObj.colorClass,
            });

            commit('setBrandNamePillsState', newBrandNamePillsArray);
        },
        removeBrandNamePill({ commit, state }, pillObj) {
            const brandNamePills = [...state.brandNamePills];

            const newBrandNamePillsArray = brandNamePills.filter(item => {
                return item.value !== pillObj.value;
            });


            commit('setBrandNamePillsState', newBrandNamePillsArray);
        },
        resetBrandNamePills({ commit }) {
            commit('setBrandNamePillsState', []);
        }
    }
}

export default BrandChecker;